import CourseController from '../../../course.controller';

class Diagram3Controller extends CourseController {

  constructor(courseService, diagramService, $translate, $scope) {
    'ngInject';

    super(courseService, diagramService, $translate, $scope);
    Object.assign(this, { diagramService, courseService });

    this.diagramId = 'diagram3a3-3';
    this.submitBtn = 'diagram3a3-3-submit';
    this.nextBtn = 'diagram3a3-3-next';
    this.diagramNumber = 3;
    this.deductive = true;
    this.deductiveSpecialModel = true;
    this.amountCorrectAnswers = 2
  }

  $postLink() {
    this.diagramService.initDraggableList(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
  }

}

export default Diagram3Controller;



// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3a3/diagram3/diagram3.controller.js